/*--------------------------------------
SLIDER PRODUCTS
 --------------------------------------*/
SliderProducts = {
  init: function () {

    var swiper = new Swiper(".swiper-products", {
      lazy: true, 
      slidesPerView: "auto",
      mousewheel: {
        invert: false,
        forceToAxis: true
      },
      allowTouchMove: true,
      speed: 600,
      freeMode: {
        enabled: false,
        sticky: true,
        momentumBounce: false
      },
      nextButton: '#button-next-collection',
      prevButton: '#button-prev-collection',
      navigation: {
        nextEl: ".swiper-button-next-collections",
        prevEl: ".swiper-button-prev-collections",
      },
      breakpoints: {
        "1435": {
          allowTouchMove: false,
        }
      }
    });

      //INITIAL
      if ($(window).width() >= 1435) {
        $(".swiper-products img").on('dragstart', function () {
          return false
        })
  
        $('.swiper-products a').on('pointerdown',
          function pointerHandler(event) {
            window.location.href = $(this).attr('href');
          }
        );
    }

  }
};

/*--------------------------------------
SLIDER PRODUCTS APPEAR
 --------------------------------------*/
SliderProductsAppear = {
  init: function () {

    $(".collection-item__title:first-child").addClass("item-collection-active");
    $(".collection-item-1").addClass("item-active");
    $(".collection-item-1 .collection-item__products").addClass("item-active-effect");
    $(".collection-item__title").click(function () {
      $(".collection-item__title").removeClass("item-collection-active");
      $(this).addClass("item-collection-active");
      var item_num = $(this).data('item-collection');
      $(".collection-item").removeClass("item-active");
      $(".collection-item-" + item_num).addClass("item-active");
      $(".collection-item .collection-item__products").removeClass("item-active-effect");
      setTimeout(function () {
        $(".collection-item-" + item_num + " .collection-item__products").addClass("item-active-effect");
      }, 100);
    });
  }
};



$(function () {
  SliderProducts.init();
  SliderProductsAppear.init();
});